import React from 'react';
import './skills.css';
import portfolioConfig from '../../config/portfolioConfig';

const Skills = () => {
  const { stackGroups } = portfolioConfig;

  return (
    <section id="skills" className="skills-section section">
      <div className="container skills-section__container">
        <div className="skills-section__intro">
          <div>
            <p className="section-eyebrow">Stack</p>
            <h2>Capabilities presented as working groups instead of fake percentages.</h2>
          </div>
          <p className="section-copy">
            One of the easiest ways portfolios start to feel auto-generated is when every skill is
            assigned an arbitrary percentage. This section now shows how the stack is actually used.
          </p>
        </div>

        <div className="skills-grid">
          {stackGroups.map((group) => (
            <article key={group.title} className="skills-card panel">
              <p className="section-eyebrow">{group.title}</p>
              <p className="skills-card__summary">{group.summary}</p>
              <div className="skills-card__chips">
                {group.items.map((item) => (
                  <span key={item}>{item}</span>
                ))}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
